
import { defineComponent } from 'vue'
import { logout } from '@/services/ControlLogin'

export default defineComponent({
  setup() {
    return { logout }
  },
})
